export default __webpack_public_path__ + "6a271fea90fa2d5b68e11de407c6ed33.png";